import { useQuery } from 'react-query'

import { unSdgService } from 'src/services/un-sdg.service'
import { QUERY_KEYS } from 'src/constants'

export const useUnSdgChanges = (id: string) => {
  return useQuery([QUERY_KEYS.UN_SDG_CHANGES, id], () => unSdgService.getUnSdgChanges(id))
}
